import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '@environments/environment';
import { ConsumeBatchCycleCommand, CreateBatchLotItemCommand } from '@app/models/inventory/commands/batch-lot-item';
import { LotItem } from '@app/models/inventory/requisition';

@Injectable({
  providedIn: 'root',
})
export class BatchLotItemProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/batch-lot-item';

  consumeBatchCycle(batchId: string, command: ConsumeBatchCycleCommand): Observable<ApiResponse<object>> {
    return this.httpClient.post<ApiResponse<object>>(`${this.baseUrl}/batch/${batchId}/consume-cycle`, command);
  }

  getLotItemsByBatch(batchId: string): Observable<ApiResponse<LotItem[]>> {
    return this.httpClient.get<ApiResponse<LotItem[]>>(`${this.baseUrl}/batch/${batchId}/lot-items`);
  }

  createLotItem(batchId: string, command: CreateBatchLotItemCommand): Observable<ApiResponse<LotItem>> {
    return this.httpClient.post<ApiResponse<LotItem>>(`${this.baseUrl}/batch/${batchId}/create-lot-item`, command);
  }
}
